import { Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="py-12 bg-foreground text-background">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg gradient-primary flex items-center justify-center">
              <Sparkles className="w-4 h-4 text-primary-foreground" />
            </div>
            <span className="font-bold text-lg">NoteGenius</span>
          </div>
          
          <div className="flex items-center gap-8 text-sm opacity-70">
            <Link to="/privacy" className="hover:opacity-100 transition-opacity">Privacy</Link>
            <Link to="/terms" className="hover:opacity-100 transition-opacity">Terms</Link>
            <Link to="/refund" className="hover:opacity-100 transition-opacity">Refund Policy</Link>
            <Link to="/contact" className="hover:opacity-100 transition-opacity">Contact Us</Link>
          </div>
          
          <p className="text-sm opacity-70">
            © 2024 NoteGenius. Made for students.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
